import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import {
  RenderToast,
  validateEmail,
  validateNestedParams,
} from "@/helper/HelperFunction";
import { useNavigate } from "react-router-dom";
import classes from "./VerifyEmail.module.css";

const VerifyEmail = ({ email, setEmail, loading, handleEmail, cmsLoading }) => {
  const navigate = useNavigate();
  const handleValidate = async () => {
    const params = {
      email,
    };
    if (!validateNestedParams(params)) return;
    if (!validateEmail(email)) {
      return RenderToast({
        type: "error",
        message: "Please enter a valid email!",
      });
    }

    handleEmail(params);
  };
  return (
    <>
      <div className={classes.formContainer}>
        <div className={classes.loginHeadingContainer}>
          <h6 className={classes.loginHeading}>Forgot Password?</h6>
          <p>Enter your email address below. We’ll send you a link.</p>
        </div>
        <div className={classes.loginForm}>
          <Input
            placeholder="Enter Your Email"
            type="email"
            value={email}
            setter={setEmail}
            label={"Email Address"}
          />
        </div>
        <Button
          className={classes.loginBtn}
          label={loading ? "Wait..." : "Continue"}
          disabled={loading}
          onClick={handleValidate}
          type="square"
        />
        <p className={classes.forgetPass}>
          <span onClick={() => navigate("/login")}>Back to login?</span>
        </p>
      </div>
    </>
  );
};

export default VerifyEmail;
